<template>
  <div class="amara-resetPassword">
    <v-snackbar
      :timeout="6000"
      :color="snackbar.color"
      :multi-line="snackbar.mode === 'multi-line'"
      :vertical="snackbar.mode === 'vertical'"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false">Close</v-btn>
    </v-snackbar>
    <div class="landing">
      <div class="img-left">
        <div class="icon">
          <img src="../assets/logo/amara_logo.png" width="250px;">
        </div>
        <div class="left-img">
        </div>
        <div class="bottom">
          <div class="bottom-footer">
            <div>
                Powered by
                <a target="_blank" href="https://www.hirexp.com/">
                    <img height="13" src="https://hirexp.com/img/logo-dark.png" alt="">
                </a>
            </div>
            <div class="second-footer">
                <a target="_blank" href="https://www.amara.ai/">Home</a>
            </div>
            <div class="third-footer">
                Made with
                <span>
                    <i class="fas fa-heart"></i>
                </span> in India
            </div>
          </div>
        </div>
      </div>
      <div class="img-right">
        <div class="icon">
          <h1 class="am-title">Reset password</h1>
        </div>
        <div class="registration">
          <div>
            <v-text-field
              id="newId1"
              v-model="new_password1"
              :append-outer-icon="e1 ? 'las la-eye-slash': 'las la-eye' "
              :type="e1 ? 'password' : 'text'"
              @click:append-outer="(e1 = !e1)"
              label="New password"
              required
              color="black"
              class="am-input"
              autocomplete="off"
            ></v-text-field>
            <!-- <input type="password" v-model="new_password1" placeholder="Password *" class="Password__field Password__field1 am-input"> -->
            <password @score="showScore" v-model='new_password1' :strength-meter-only="true" class="d-none"/>
            <!-- <span
              style="height:30px;position:absolute;right:-8px;top:-3px;padding:10px;cursor:pointer;"
              @click="showPassword()"
              class="input-group-text lable-border"
            >
              <v-icon v-if="showPass">laa la-eye</v-icon>
              <v-icon v-if="!showPass">laa la-eye-slash</v-icon>
            </span> -->
          </div>
          <div>
            <v-text-field
              id="newId2"
              autocomplete="off"
              v-model="new_password2"
              :append-outer-icon="e2 ? 'las la-eye-slash' : 'las la-eye'"
              :type="e2 ? 'password' : 'text'"
              @click:append-outer="(e2 = !e2)"
              label="Confirm password"
              required
              color="black"
              class="am-input"
            ></v-text-field>
            <vue-recaptcha
              ref="Grecaptcha"
              @verify="onCaptchaVerified1"
              @expired="onCaptchaExpired1"
              size="invisible"
              sitekey="6LcRPbsUAAAAAOTgJ2YhwKLCNeQoWDu-7fP3xuyt"
            ></vue-recaptcha>
          </div>
          <div>
            <div class="text-left" style="font-weight: bold;color:black;font-size:14px">Password strength :
              <span style="color:#000" v-if="passwordScore == 0 || passwordScore == 1">Weak</span>
              <span style="color:#000" v-if="passwordScore == 2">Good</span>
              <span style="color:#000" v-if="passwordScore == 3">Strong</span>
              <span style="color:#000" v-if="passwordScore == 4">Too strong</span>
            </div>
          </div>
          <div class="mb-4">
            <p v-for='(error, e) in passwordValidation.errors' :key="e" v-if="error == '1'" class="notAvailable text-left w-100">Must contain at least one lowercase letter.</p>
            <p v-if="passwordValidation.errors[0] != '1' && new_password1" class="Available text-left w-100">Must contain at least one lowercase letter.</p>
            <p v-for='(error, e) in passwordValidation.errors' :key="e" v-if="error == '2'" class="notAvailable text-left w-100">Must contain at least one uppercase letter.</p>
            <p v-if="passwordValidation.errors[0] != '2' && passwordValidation.errors[1] != '2'" class="Available text-left w-100">Must contain at least one uppercase letter.</p>
            <p v-for='(error, e) in passwordValidation.errors' :key="e" v-if="error == '3'" class="notAvailable text-left w-100">Must contain at least 8 characters minimum.</p>
            <p v-if="passwordValidation.errors[0] != '3' && passwordValidation.errors[1] != '3' && passwordValidation.errors[2] != '3'" class="Available text-left w-100">Must contain at least 8 characters minimum.</p>
            <p v-for='(error, e) in passwordValidation.errors' :key="e" v-if="error == '4'" class="notAvailable text-left w-100">Must contain at least one number.</p>
            <p v-if="passwordValidation.errors[0] != '4' && passwordValidation.errors[1] != '4' && passwordValidation.errors[2] != '4' && passwordValidation.errors[3] != '4'" class="Available text-left w-100">Must contain at least one number.</p>
            <p v-for='(error, e) in passwordValidation.errors' :key="e" v-if="error == '5'" class="notAvailable text-left w-100">Must contain at least one special character.</p>
            <p v-if="passwordValidation.errors[0] != '5' && passwordValidation.errors[1] != '5' && passwordValidation.errors[2] != '5' && passwordValidation.errors[3] != '5' && passwordValidation.errors[4] != '5'" class="Available text-left w-100">Must contain at least one special character.</p>
            <p class=" text-left w-100" style="font-size: 14px;
    color: #000;
    opacity: 1;
    margin-bottom: 5px;"><span style="margin-left:5px;">*</span><span style="margin-left:15px;">Password</span> should not be in a list of <a href="https://gist.github.com/roycewilliams/281ce539915a947a23db17137d91aeb7" target="_blank" rel="noopener noreferrer">common passwords.</a></p>
            <p class=" text-left w-100" style="font-size: 14px;
    color: #000;
    opacity: 1;
    margin-bottom: 5px;"><span style="margin-left:5px;">*</span><span style="margin-left:15px;">Password</span> should not be in your last 3 used passwords.</p>
          </div>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="px-10 white--text" @click="getRecapcha()">Reset</v-btn>
          </div>
          <div class="or-separator">
            <span>OR</span>
          </div>
          <div class="pt-3">
            <v-btn color="primary" class="white--text w-100" to="/login">
              Sign in
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import {
//   VSnackbar,
//   VTextField,
//   VAlert
// } from 'vuetify'
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';
import Password from 'vue-password-strength-meter';

export default {
  name: 'ResetPassword',
  components: {
    Password,
    VueRecaptcha
  },
  data () {
    return {
      // newId1: 'newId1-' + Date.now().toString(),
      // newId2: 'newId2-' + Date.now().toString(),
      autoPlay: true,
      e1: true,
      e2: true,
      passwordScore: null,
      showPass: false,
      showPass1: false,
      rules: [
        { message: '1', valid: '5', regex: /[a-z]+/ },
        { message: '2', valid: '6', regex: /[A-Z]+/ },
        { message: '3', valid: '7', regex: /.{8,}/ },
        { message: '4', valid: '8', regex: /[0-9]+/ },
        // eslint-disable-next-line no-useless-escape
        { message: '5', valid: '9', regex: /([-+=_!@#$%^&*.,;:'\"<>/?`~\[\]\(\)\{\}\\\|\s])/ }
      ],
      // items: [
      //   {
      //     src: require('../assets/gradiant1.png'),
      //     heading: 'Customized workflow',
      //     text: 'Amara workflow can be easily customized to meet your employee engagement and candidate experience objectives.'
      //   },
      //   {
      //     src: require('../assets/gradiant2.png'),
      //     heading: 'Scalable model',
      //     text: 'Amara is designed to scale horizontally to handle thousands of users and chat sessions per day while providing the fastest response time.'
      //   },
      //   {
      //     src: require('../assets/gradiant3.png'),
      //     heading: 'Ad-hoc campaigns',
      //     text: 'Create ad-hoc campaigns to further deep dive into specific problem areas and gather insights at any given point of time'
      //   },
      //   {
      //     src: require('../assets/gradiant4.png'),
      //     heading: 'Seamless integrations',
      //     text: 'Amara can easily integrate with your existing HRIS and the chats can be deployed across multiple communication channels like Emails, SMS, WhatsApp, Slack and many more.'
      //   }
      // ],
      // e1: true,
      disabled: false,
      loginActive: false,
      forgotPasswordToggle: false,
      email: null,
      forgotEmail: null,
      password: null,
      new_password1: null,
      new_password2: null
    };
  },
  mounted () {
    const t = document.getElementById('newId1');
    t.autocomplete = 'false';
  },
  computed: {
    notSamePasswords () {
      if (this.passwordsFilled) {
        return (this.new_password1 !== this.checkPassword);
      } else {
        return false;
      }
    },
    passwordsFilled () {
      return (this.new_password1 !== '' && this.checkPassword !== '');
    },
    passwordValidation () {
      const errors = [];
      const success = [];
      for (const condition of this.rules) {
        if (!condition.regex.test(this.new_password1)) {
          errors.push(condition.message);
        }
        if (condition.regex.test(this.new_password1)) {
          success.push(condition.valid);
        }
      }

      if (errors.length === 0) {
        return { valid: true, errors };
      } else {
        return { valid: false, errors };
      }
    },
    ...mapState({
      snackbar: state => state.snackbar
    })
  },
  methods: {
    showPassword () {
      this.showPass = !this.showPass;
      const passwordField = document.querySelector('.Password__field1');
      if (passwordField.getAttribute('type') === 'password') passwordField.setAttribute('type', 'text');
      else passwordField.setAttribute('type', 'password');
    },
    showConfirmPassword () {
      this.showPass1 = !this.showPass1;
      const passwordField = document.querySelector('.confirmPassword');
      if (passwordField.getAttribute('type') === 'password') passwordField.setAttribute('type', 'text');
      else passwordField.setAttribute('type', 'password');
    },
    showScore (score) {
      this.passwordScore = score;
    },
    login () {
      if (this.email && this.password) {
        this.getData();
      }
    },
    forgot () {
      if (this.forgotEmail === null) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Please add email to send link.'
        });
      } else {
        this.disabled = true;
        axios.post(`${process.env.VUE_APP_API_URL}password/reset/Amara`, {
          email: this.forgotEmail
        }).then(() => {
          this.disabled = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'success',
            show: true,
            text: 'Reset link sent successfully, Please check your mailbox!'
          });
          this.email = JSON.parse(JSON.stringify(this.forgotEmail));
          this.forgotEmail = null;
          this.fpToggle();
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Some error occurred, Please try again later!'
            });
          }
        });
      }
    },
    fpToggle () {
      this.forgotPasswordToggle = !this.forgotPasswordToggle;
    },
    getRecapcha () {
      this.$refs.Grecaptcha.execute();
    },
    onCaptchaVerified1: function (recaptchaToken) {
      if (!this.new_password1 || !this.new_password2) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Please fill all fields!',
          type: 'warn'
        });
        return;
      }
      if (this.new_password1.length < 8 || this.new_password2.length < 8) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Your password must contain at least 8 characters!',
          type: 'warn'
        });
        return;
      }
      if (this.new_password1 !== this.new_password2) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Password fields didn\'t match!'
        });
        return;
      }
      if (this.passwordValidation.errors.length > 0) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          text: 'Password format is not correct!',
          show: true
        });
        return;
      }
      if (!this.new_password1 || !this.new_password2) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Please fill all fields!'
        });
        return;
      }
      if (this.new_password1.length < 8 || this.new_password2.length < 8) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Your password must contain at least 8 characters!',
          type: 'warn'
        });
        return;
      }
      if (this.new_password1 !== this.new_password2) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Your new password fields didn\'t match!'
        });
        return;
      }
      this.disabled = true;
      axios.post(`${process.env.VUE_APP_API_URL}password/reset/confirm/`, {
        new_password1: this.new_password1,
        new_password2: this.new_password2,
        uid: this.$route.params.uid,
        token: this.$route.params.token,
        recaptcha_token: recaptchaToken
      }).then(() => {
        this.disabled = false;
        this.$store.dispatch('updateSnackbar', {
          color: 'success',
          show: true,
          text: 'Password was changed successfully!'
        });
        this.$router.push({ path: '/login' }).catch(() => {});
        this.toggle('login');
      }, (resp) => {
        this.disabled = false;
        if (resp && resp.body && resp.body.new_password2) {
          if (resp.body.new_password2[0]) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: `${resp.body.new_password2[0]}`
            });
          }
        }
        if (resp.body && resp.body.token && resp.body.token[0] === 'Invalid value') {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Your token has been expired, please try sending password reset link again.'
          });
          return;
        }
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Oops! This is embarrasing, Please try again later!'
        });
      });
    },
    onCaptchaExpired1: function () {
      this.$refs.recaptcha.reset();
    },
    ResetPassword () {
      if (!this.new_password1 || !this.new_password2) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Please fill all fields!',
          type: 'warn'
        });
        return;
      }
      if (this.new_password1.length < 8 || this.new_password2.length < 8) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Your password must contain at least 8 characters!',
          type: 'warn'
        });
        return;
      }
      if (this.new_password1 !== this.new_password2) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Password fields didn\'t match!'
        });
        return;
      }
      if (this.passwordValidation.errors.length > 0) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          text: 'Password format is not correct!',
          show: true
        });
        return;
      }
      if (!this.new_password1 || !this.new_password2) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Please fill all fields!'
        });
        return;
      }
      if (this.new_password1.length < 8 || this.new_password2.length < 8) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Your password must contain at least 8 characters!',
          type: 'warn'
        });
        return;
      }
      if (this.new_password1 !== this.new_password2) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Your new password fields didn\'t match!'
        });
        return;
      }
      this.disabled = true;
      axios.post(`${process.env.VUE_APP_API_URL}password/reset/confirm/`, {
        new_password1: this.new_password1,
        new_password2: this.new_password2,
        uid: this.$route.params.uid,
        token: this.$route.params.token
      }).then(() => {
        this.disabled = false;
        this.$store.dispatch('updateSnackbar', {
          color: 'success',
          show: true,
          text: 'Password was changed successfully!'
        });
        this.$router.push({ path: '/login' }).catch(() => {});
        this.toggle('login');
      }, (resp) => {
        this.disabled = false;
        if (resp && resp.body && resp.body.new_password2) {
          if (resp.body.new_password2[0]) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: `${resp.body.new_password2[0]}`
            });
          }
        }
        if (resp.body && resp.body.token && resp.body.token[0] === 'Invalid value') {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Your token has been expired, please try sending password reset link again.'
          });
          return;
        }
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Oops! This is embarrasing, Please try again later!'
        });
      });
    },
    toggle (e) {
      if (e === 'login') {
        this.loginActive = true;
      } else {
        this.loginActive = !this.loginActive;
      }
    },
    getData () {
      this.disabled = true;
      axios.post(`${process.env.VUE_APP_API_URL}login`, {
        username: this.email,
        password: this.password
      }).then((response) => {
        // this.$Progress.finish();
        this.refreshing = true;
        if (response.data && response.data.status === 200) {
          // If first time login
          if (response.data.last_login === null || response.data.profile_status === false) {
            this.$store.dispatch('createTempSession', response.data);
            this.$router.push('/first-login');
          } else {
            this.$store.dispatch('createSession', response.data);
            setTimeout(() => {
              if (this.$route.query.redirect && this.$route.query.redirect !== undefined) {
                this.$router.push(this.$route.query.redirect);
              } else {
                if (this.user.milestone_active) {
                  this.$router.push('/');
                } else if (this.user.adhoc_active) {
                  this.$router.push('/ad-hoc');
                }
              }
            }, 400);
          }
        } else {
          this.disabled = false;
          this.refreshing = true;
          if (response.data && response.data.message) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: response.data.message
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Wrong username or password!'
            });
          }
        }
      }, (response) => {
        throw new Error(response);
      });
    },
    close (e) {
      e.stopPropogation();
      this.containerActive = !this.containerActive;
    }
  },
  beforeMount () {
    if (!this.$route.params.uid || !this.$route.params.token) {
      this.$router.push('/');
    }
  }
};

</script>

<style lang="scss" >
/* General variables */
/* General configurations */
* {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

body {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 1em;
}

button {
  background-color: transparent;
  padding: 0;
  border: 0;
  outline: 0;
  cursor: pointer;
}

input {
  background-color: transparent;
  padding: 0;
  border: 0;
  outline: 0;
}
input[type="submit"] {
  cursor: pointer;
}
input::-webkit-input-placeholder {
  font-size: 0.85rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  letter-spacing: 0.1rem;
  color: #ccc;
}
input:-ms-input-placeholder {
  font-size: 0.85rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  letter-spacing: 0.1rem;
  color: #ccc;
}
input::-ms-input-placeholder {
  font-size: 0.85rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  letter-spacing: 0.1rem;
  color: #ccc;
}
input::placeholder {
  font-size: 0.85rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  letter-spacing: 0.1rem;
  color: #ccc;
}

/* Animations */
@-webkit-keyframes bounceLeft {
  0% {
    -webkit-transform: translate3d(100%, -50%, 0);
            transform: translate3d(100%, -50%, 0);
  }
  50% {
    -webkit-transform: translate3d(-30px, -50%, 0);
            transform: translate3d(-30px, -50%, 0);
  }
  100% {
    -webkit-transform: translate3d(0, -50%, 0);
            transform: translate3d(0, -50%, 0);
  }
}
@keyframes bounceLeft {
  0% {
    -webkit-transform: translate3d(100%, -50%, 0);
            transform: translate3d(100%, -50%, 0);
  }
  50% {
    -webkit-transform: translate3d(-30px, -50%, 0);
            transform: translate3d(-30px, -50%, 0);
  }
  100% {
    -webkit-transform: translate3d(0, -50%, 0);
            transform: translate3d(0, -50%, 0);
  }
}
@-webkit-keyframes bounceRight {
  0% {
    -webkit-transform: translate3d(0, -50%, 0);
            transform: translate3d(0, -50%, 0);
  }
  50% {
    -webkit-transform: translate3d(calc(100% + 30px), -50%, 0);
            transform: translate3d(calc(100% + 30px), -50%, 0);
  }
  100% {
    -webkit-transform: translate3d(100%, -50%, 0);
            transform: translate3d(100%, -50%, 0);
  }
}
@keyframes bounceRight {
  0% {
    -webkit-transform: translate3d(0, -50%, 0);
            transform: translate3d(0, -50%, 0);
  }
  50% {
    -webkit-transform: translate3d(calc(100% + 30px), -50%, 0);
            transform: translate3d(calc(100% + 30px), -50%, 0);
  }
  100% {
    -webkit-transform: translate3d(100%, -50%, 0);
            transform: translate3d(100%, -50%, 0);
  }
}
/* Page background */
.user {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 100%;
  height: 100vh;
  background: url("https://s3.ap-south-1.amazonaws.com/hirexp/static/bacground-login.jpeg") no-repeat center;
  background-size: cover;
}
.user_options-container {
  position: relative;
  width: 80%;
}
.user_options-text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  width: 100%;
  background-color: rgba(34, 34, 34, 0.85);
  border-radius: 3px;
}

/* Registered and Unregistered user box and text */
.user_options-registered,
.user_options-unregistered {
  width: 50%;
  padding: 75px 45px;
  color: #fff;
  font-weight: 300;
}

.user_registered-title,
.user_unregistered-title {
  margin-bottom: 15px;
  font-size: 1.66rem;
  line-height: 1em;
}

.user_unregistered-text,
.user_registered-text {
  font-size: 0.83rem;
  line-height: 1.4em;
}

.user_registered-login,
.user_unregistered-signup {
  margin-top: 30px;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 10px 30px;
  color: #fff;
  text-transform: uppercase;
  line-height: 1em;
  letter-spacing: 0.2rem;
  -webkit-transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}
.user_registered-login:hover,
.user_unregistered-signup:hover {
  color: rgba(34, 34, 34, 0.85);
  background-color: #ccc;
}

/* Login and signup forms */
.user_options-forms {
  position: absolute;
  top: 50%;
  left: 30px;
  width: calc(50% - 30px);
  min-height: 470px;
  background-color: #fff;
  border-radius: 3px;
  -webkit-box-shadow: 2px 0 15px rgba(0, 0, 0, 0.25);
          box-shadow: 2px 0 15px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  -webkit-transition: -webkit-transform 0.4s ease-in-out;
  transition: -webkit-transform 0.4s ease-in-out;
  transition: transform 0.4s ease-in-out;
  transition: transform 0.4s ease-in-out, -webkit-transform 0.4s ease-in-out;
  -webkit-transform: translate3d(100%, -50%, 0);
          transform: translate3d(100%, -50%, 0);
}
.user_options-forms .user_forms-login {
  -webkit-transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out;
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out;
}
.user_options-forms .forms_title {
  margin-bottom: 45px;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1em;
  text-transform: uppercase;
  color: #e8716d;
  letter-spacing: 0.1rem;
}
.user_options-forms .forms_field:not(:last-of-type) {
  margin-bottom: 20px;
}
.user_options-forms .forms_field-input {
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding: 6px 20px 6px 0;
  font-family: "Montserrat", sans-serif;
  font-size: 1rem;
  font-weight: 300;
  color: gray;
  letter-spacing: 0.1rem;
  -webkit-transition: border-color 0.2s ease-in-out;
  transition: border-color 0.2s ease-in-out;
}
.user_options-forms .forms_field-input:focus {
  border-color: gray;
}
.user_options-forms .forms_buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-top: 35px;
}
.user_options-forms .forms_buttons-forgot {
  font-family: "Montserrat", sans-serif;
  letter-spacing: 0.1rem;
  color: #ccc;
  text-decoration: underline;
  -webkit-transition: color 0.2s ease-in-out;
  transition: color 0.2s ease-in-out;
}
.user_options-forms .forms_buttons-forgot:hover {
  color: #b3b3b3;
}
.user_options-forms .forms_buttons-action {
  background-color: #e8716d;
  border-radius: 3px;
  padding: 10px 35px;
  font-size: 1rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  -webkit-transition: background-color 0.2s ease-in-out;
  transition: background-color 0.2s ease-in-out;
}
.user_options-forms .forms_buttons-action:hover {
  background-color: #e14641;
}
.user_options-forms .user_forms-signup,
.user_options-forms .user_forms-login {
  position: absolute;
  top: 70px;
  left: 40px;
  width: calc(100% - 80px);
  opacity: 0;
  visibility: hidden;
  -webkit-transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out, -webkit-transform 0.5s ease-in-out;
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out, -webkit-transform 0.5s ease-in-out;
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out, transform 0.5s ease-in-out;
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out, transform 0.5s ease-in-out, -webkit-transform 0.5s ease-in-out;
}
.user_options-forms .user_forms-signup {
  -webkit-transform: translate3d(120px, 0, 0);
          transform: translate3d(120px, 0, 0);
}
.user_options-forms .user_forms-signup .forms_buttons {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}
.user_options-forms .user_forms-login {
  -webkit-transform: translate3d(0, 0, 0);
          transform: translate3d(0, 0, 0);
  opacity: 1;
  visibility: visible;
}

/* Triggers */
.user_options-forms.signup-click {
  -webkit-animation: bounceLeft 1s forwards;
          animation: bounceLeft 1s forwards;
}
.user_options-forms.signup-click .user_forms-signup {
  opacity: 1;
  visibility: visible;
  -webkit-transform: translate3d(0, 0, 0);
          transform: translate3d(0, 0, 0);
}
.user_options-forms.signup-click .user_forms-login {
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translate3d(-120px, 0, 0);
          transform: translate3d(-120px, 0, 0);
}
.user_options-forms.login-click {
  -webkit-animation: bounceRight 1s forwards;
          animation: bounceRight 1s forwards;
}
.user_options-forms.login-click .user_forms-signup {
  opacity: 0;
  visibility: hidden;
}
.user_options-forms.login-click .user_forms-login {
  opacity: 1;
  visibility: visible;
  -webkit-transform: translate3d(0, 0, 0);
          transform: translate3d(0, 0, 0);
}

/* Responsive */
@media screen and (max-width: 620px) {
  .user_options-unregistered, .user_options-registered {
    display: none;
  }
  .user_options-forms {
    left: 0;
    width: 100%;
  }
}
@media screen and (max-width: 990px) {
  .user_options-forms {
    min-height: 510px;
  }
  .user_options-forms .forms_buttons {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }
  .user_options-forms .user_forms-login .forms_buttons-action {
    margin-top: 30px;
  }
  .user_options-forms .user_forms-signup,
  .user_options-forms .user_forms-login {
    top: 50px;
  }

  .user_options-registered,
  .user_options-unregistered {
    padding: 50px 45px;
  }
}

 .amara-resetPassword{
.login-bg {
  // height: calc(100vh - 87px);
  background: url(../assets/dashboard.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  &:after {
    content: '\A';
    position: absolute;
    // width: 100%; height:calc(100vh - 87px);
    left:0;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background:rgba(0,0,0,0.6) no-repeat center center fixed;
    opacity: 0.8;
    transition: all 1s;
    -webkit-transition: all 1s;
  }
}
.login-div {
  z-index: 1;
}

.v-window__container{
    height: 100% !important;
  }
  .v-responsive{
    height:100% !important;
  }

  .fa-chevron-right, .fa-chevron-left{
    font-size: 15px !important;
    padding: 10px;
  }
  .fa-circle{
    font-size: 10px !important;
  }
.carousel-heading{
    width:100%;
    position: absolute;
    top: 40%;
    font-size: 24px !important;
    padding: 0 15px;
    font-weight: 500;
    margin: 0;
    color:white;
    font-family: "Montserrat", Arial, Tahoma, sans-serif !important;
}
.carousel-text{
  width:100%;
    position: absolute;
    top: 47%;
    font-size: 16px !important;
    padding: 0 10%;
    margin: 0;
    color:rgb(235, 229, 229);
    font-family: "Montserrat", Arial, Tahoma, sans-serif !important;
}

.login-carousel-request-button{
  width:100%;
  position: absolute;
  top: 65%;
  right:24%;
  font-size: 16px !important;
  text-align: center;
  padding: 0 10%;
  margin: 0;
  color:rgb(235, 229, 229);
  font-family: "Montserrat", Arial, Tahoma, sans-serif !important;
}
@media only screen and (max-width: 1024px) {
  .login-carousel-request-button {
    right:16%;
    top: 67%;
  }
}
.v-carousel__controls{
  background: transparent;
}
.v-label{
  margin-top:-5px;
}
.v-input input{
  font-size: 14px;
}
.logo-login{
  width:80px;
}
@media only screen and (max-width: 1000px) {
  .login-carousel {
    display: none;
  }
}
.login-page{
  width:67%;
   position:absolute;
    right:0;
    padding: 4% 8%
}
@media only screen and (max-width: 1024px) {
  .login-page {
   padding: 10% 8%

  }
}
@media only screen and (max-width: 1000px) {
  .login-page {
    position: static !important;
    width: 100%;

  }
}
@media only screen and (max-width: 1000px) {
  .login-bottom-line {
    width: 100% !important;

  }
}

@media only screen and (max-width: 1000px) {
  .login-input-field {
    width: 100% !important;

  }
}
.RequestDemoButton {
    display:none;
}
@media only screen and (max-width: 1000px) {
  .RequestDemoButton {
    display:block;

  }
}
@media only screen and (max-width: 624px) {
  .RequestDemoButton {
    text-align: center;

  }
}
.layout.row.wrap.login-bottom{
    position: fixed;
    bottom: 0;
    right: 10px;
    width: 65% !important;
}
@media only screen and (max-width: 1000px) {
  .layout.row.wrap.login-bottom {
    width:97% !important;

  }
}
@media only screen and (max-width: 624px) {
  .layout.row.wrap.login-bottom {
    position: static;

  }
}
.amaraDoc, .amaraDoc *{
    color:rgb(73, 73, 73);
    font-size: 11px;
    padding: 10px auto;
}
@media only screen and (max-width: 600px) {
  .hideinmobile {
    display: none;

  }
}
}

</style>

<style lang="scss">
.am-input {
  .v-input__icon--prepend, .v-input__icon--append {
    i, button {
      color: #000 !important;
    }
  }
  .v-input__slot {
    &::before {
      border-color: #000 !important;
    }
  }
  .v-text-field__slot {
    .v-label {
      color: #000 !important;
    }
    input {
      color: #000 !important;
      &::placeholder {
        color: #000 !important;
        opacity: 1;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.landing {
  width: 100%;
  height: 100vh;
  display: flex;
  .img-left {
    position: relative;
    flex-grow: 1;
    background: #f5f5f7;
    .icon {
      position: absolute;
      top: 4%;
      left: 4%;
    }
    .left-img {
      transform: scale(.85);
      height: 100%;
      // background-image: url('../assets/login-banner.png');
      background-image: url('../assets/Data-report.svg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    .bottom {
      width: 100%;
      position: absolute;
      bottom: 0px;
      left: 0;
      .bottom-footer {
        padding: 0 6px;
        display: flex;
        justify-content: space-between;
        .third-footer {
          i {
            color: red;
          }
        }
      }
    }
  }
  .img-right {
    background-color: #fff;
    width: 38%;
    overflow: hidden;
    color: #fff;
    background: #ffffff;
    // background-image: -webkit-gradient(linear, right top, left bottom, from(transparent), to(rgba(51, 148, 255, 0.18)));
    // background-size: 100% 400%;
    .icon {
      margin-top: 60px;
      .am-title {
        text-align: center;
        font-size: 24px;
        color: #000;
      }
      .am-sub-title {
        text-align: center;
        font-size: 18px;
        color: #000;
      }
    }
    .registration {
      display: inline-block;
      width: 80%;
      margin-top: 5%;
      margin-left: 10%;
      .or-separator {
        text-transform: uppercase;
        font-weight: 600;
        font-size: 13px;
        text-align: center;
        border-bottom: 1px solid #e1e6eb;
        margin: -10px 0 24px;
        span {
          background: #fff;
          // background-image: -webkit-gradient(linear, right top, left bottom, from(transparent), to(rgba(51, 148, 255, 0.18)));
          // background-size: 100% 400%;
          color: #000000;
          padding: 10px 10px;
          display: inline-block;
          position: relative;
          top: 20px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .landing {
    .img-left {
      position: absolute;
      width: 100%;
      z-index: -1;
  }
  .img-right {
    width: 100%;
    .registration {
      background-color: rgba(255, 255, 255, 0.001);
      padding: 10px;
      border-radius: 0.5rem;
      box-shadow: 3px 5px 15px rgba(0, 0, 0, .4);
        .title {
          color: #666;
        }
      }
    }
  }
}
.notAvailable {
  // color: white;
  font-size: 14px;
  color: #000;
  opacity: 1;
  margin-bottom: 5px;;
  &::before {
    content: "\f058";
    font-family: "Font Awesome 5 Free";
    color: #000;
    opacity: 1;
    font-size: 14px;
    padding-right: 10px;
  }
}
.Password__field {
  background: #000;
  border-radius: 0 !important;
  letter-spacing: 0.1rem !important;
  background-color: #000 !important;
  border: 1px solid #ccc  !important;
  padding: 6px 20px 6px 6px  !important;
  margin-bottom: 10px;
}
.Password__strength-meter {
  display: none !important;
}

.hints {
  max-width:400px;
  padding:1em;
  background:whitesmoke;
  margin: 1em 0;
  font-size: .9em;
  color:darken(#D4DEDF, 50%);
  h2 {
    margin: .5em 0 .2em 0;
  }
  p {
    margin: 0;
    padding-left:.5em;
    &::before {
      content:"✓";
      font-size:.9em;
      display:inline-block;
    }
}
}
.Password__icons {
  display: none !important;
}
.Available {
  color: green;
  opacity: 1;
  font-size: 14px;
  display: inline-block;
  margin-bottom: 5px;;
  &::before {
    content: "\f058";
    font-family: "Font Awesome 5 Free";
    color: green;
    opacity: 1;
    padding-right: 10px;
  }
}
</style>
